// components/ErrorBoundary.jsx
import React, { Component } from 'react';
import { Icon } from '@iconify/react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, errorMessage: error.toString() };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Dynamic Layout Compiler Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div dir='rtl' className="w-full h-screen flex flex-col items-center justify-center bg-bg-primary text-red-500">
           <Icon icon="solar:danger-triangle-bold-duotone" className="text-6xl mb-4" />
           <p className="font-bold text-xl mb-2">عذراً، حدث خطأ في هيكل النظام</p>
           <p className="text-sm opacity-80" dir="ltr">{this.state.errorMessage}</p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;